var $4dc1681028cb611b$exports = {};
$4dc1681028cb611b$exports = {
    "colorFormat": `V\xe4rimuoto`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$4dc1681028cb611b$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
